export enum AddressType {
  DEFAULT = "",
  HOME = "Home",
  BUSINESS = "Business",
  BILLING = "Billing",
  SHIPPING = "Shipping",
}
